import { Layout } from "antd";
import { motion } from "framer-motion"; // Import motion from Framer Motion
import { Outlet } from "react-router-dom";
import Sidebar from "./sideNav/sideBar";

import TopBar from "./topBar/TopBar";

const { Content } = Layout;

const MainLayout = ({ searchTerm, setSearchTerm }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-row  h-screen w-screen overflow-hidden bg-[#F3F6F5] "
    >
      <Layout className="bg-[#F3F6F5] mt-3 h-screen ml-2">
        <Sidebar />
      </Layout>
      <div className="w-full min-w-0 overflow-x-hidden">
        <div className="p-2 mt-2 max-w-full md:max-w-[98%] lg:max-w-[98%]">
          <TopBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className="p-0 bg-gray-100 rounded-xl ml-1 mr-2 mt-[-1.25rem] w-[98%]">
          <Content className="flex-grow">
            <div className="mb-5 h-full w-[100%]">
              <Outlet />
            </div>
          </Content>
        </div>
      </div>
    </motion.div>
  );
};

export default MainLayout;
